import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.5 19H13.078L20.853 11.233C20.947 11.14 21 11.013 21 10.88C21 10.748 20.947 10.62 20.854 10.526L14.474 4.14601C14.279 3.95101 13.962 3.95101 13.767 4.14601L3.14698 14.766C2.95198 14.961 2.95198 15.278 3.14698 15.473L7.51698 19.853C7.52298 19.859 7.53098 19.861 7.53698 19.866C7.57898 19.904 7.62498 19.938 7.67798 19.96C7.73798 19.986 7.80298 20 7.86998 20H21.5C21.776 20 22 19.776 22 19.5C22 19.224 21.776 19 21.5 19V19ZM14.12 5.20701L19.793 10.88L16.958 13.712L11.287 8.04001L14.12 5.20701ZM8.07798 19L4.20698 15.12L10.58 8.74701L16.251 14.418L11.663 19H8.07798Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'Eraser');

export default Icon;
